import {AppData, Lightning} from "@lightningjs/sdk"
import { Base, TextBox } from "@lightningjs/ui-components"
import { AppSetup } from "../../../app-setup"
import { Helper } from "../../../helper"

export default class EPGProgramUI extends Base {
    [x: string]: any
    _isActive = false
    _isFocused = false
    _focusColor: number = 0xffffffff

    static override _template() {
        return  {
            rect: true,
            color: 0x00000000,
            clipping: true,
            collision: true,
            Wrapper: {

            }
        }
    }

    static get __componentName(): string {
        return 'EPGProgramUI'
    }

    static get tags() {
        return ['Wrapper']
    }

    static get properties() {
        return ['title','index', 'channelIndex']
    }

    _update() {
        if (!this._isActive) return

        const focusColor = this._isFocused ? this._focusColor : 0x1EFFFFFF;
        const labelMaxW = Math.max(0, this.finalW - 30)

        ;(this as any).tag('Wrapper').patch({
            Background: {
                w: this.finalW - 10,
                h: this.finalH - 10,
                rect: true,
                color: focusColor,
                zIndex: 1
                // shader is intentionally absent — patching without it leaves the existing shader untouched
            },
            Label: {
                zIndex: 2,
                type: TextBox,
                fixed: true,
                visible: this.finalW >= 100,
                w: labelMaxW,
                h: this.finalH - 10,
                content: this._title,
                style: {
                    offsetX: 20,
                    offsetY: 35,
                    textStyle: {
                        fontSize: 26,
                        fontFace: this._isFocused ? Helper.getFontFamily('Black') : Helper.getFontFamily('Regular'),
                        textColor: 0xffffffff,
                        wordWrap: false,
                        wordWrapWidth: labelMaxW,
                        textOverflow: 'ellipsis',
                        maxLinesSuffix: '...',
                        textAlign: 'left'
                    }
                }
            }
        })
    }

    override getFocusScale() {
        return 1
    }

    override _init(): void {
        this._focusColor = Helper.getHexaColor(
            (AppData as AppSetup).appState?.getAppApiConfig()?.appLayoutConfig.textfocuscolor
        ) || 0xffffffff
    }

    override _active(): void {
        this._isActive = true
        this._update()
        // Set rounded-rect shader once per activation — _update() intentionally omits it so it is never recreated mid-navigation
        const bg = (this as any).tag('Wrapper').tag('Background')
        if (bg) bg.shader = { type: Lightning.shaders.RoundedRectangle, radius: 10 }
    }

    override _inactive(): void {
        this._isActive = false
        this._update()
    }

    override _focus(): void {
        this._isFocused = true
        this._update()
    }

    override _unfocus(): void {
        this._isFocused = false
        this._update()
    }

    _handleScroll(obj: any) {
        const direction = (obj?.wheelDeltaY > 0) ? 'up' : 'down'
        ;(this as any).fireAncestors('$channelListScrolled', direction)
        return true
    }

    _handleClick() {
        ;(this as any).fireAncestors('$programTileClicked', this._channelIndex, this)
        return true
    }
}
